/** Games type */
export enum GroupType {
	/** Trivia game */
	Trivia = 0,
    	/** Poll game */
	Poll = 1,
	/** Predictor game */
	Predictor = 2
}